<template>
  <div>
    <div
      v-if="visibility"
      ref="scrollableWrapper"
      class="question-block scrollable-wrapper"
    >
      <div class="question-block-quiz">
        <div
          v-if="showQuizBlock"
          class="info-block"
        >
          <div class="info-block-content">
            <div class="info-block-description">
              <div class="top-block">
                <img
                  :src="logoIcon"
                  alt="logo"
                />
              </div>
              <div>
                <div class="questionWrapper">
                  <img
                    v-if="activeQuestion.questionStepIcon"
                    class="question-step-icon"
                    :class="getDropShadowClass"
                    :src="require(`@/assets/quiz/${activeQuestion.questionStepIcon}`)"
                    alt="questionStepIcon"
                  />

                  <h1
                    class="questionHeader"
                    v-html-safe="$t(`quiz.${activeQuestion.question}`)"
                  >
                  </h1>
                </div>
                <div class="workspace-content">
                  <p
                    v-if="activeQuestion.description1"
                    class="workspace-content-descriptions help-optimize-maximum-efficiency"
                  >
                    {{ $t(`quiz.${activeQuestion.description1}`) }}
                  </p>
                  <p
                    v-if="activeQuestion.description2"
                    class="workspace-content-descriptions"
                  >
                    <span>{{ $t(`quiz.${activeQuestion.description2}`) }}</span>
                    <span class="quiz-smiling-emoji">
                      <img
                        v-if="activeQuestion.emoji"
                        :src="require(`@/assets/quiz/emojis/${activeQuestion.emoji}`)"
                        width="20"
                        height="20"
                        alt="emoji"
                      >
                  </span>
                  </p>
                </div>
              </div>
              <div v-if="active" class="return-button" @click="goBack">
                <v-btn
                  class="quiz-exit-btn"
                  elevation="0"
                  block
                >
                  <img
                    :src="backArrowIcon"
                    alt="back"
                    width="16"
                    height="16"
                  >
                  <span class="return-button-text">
                    {{ $t('common.back') }}
                  </span>
                </v-btn>
              </div>
            </div>
          </div>
        </div>
      </div>

        <!--ОТВЕТЫ QUIZ-->
        <quiz-answers
          :active-question="activeQuestion"
          :show-back-button="showBackButton"
          @back="back"
          @select="select"
          @handleClick="handleClick"
          @close="close"
        />
    </div>
      <dialog-quiz-exit
        v-if="dialogs.quizLeavePrompt && visibility"
        @close="close"
      />
  </div>
</template>
<script>

import QuizAnswers from "@/components/quiz/QuizAnswers.vue";
import { mapGetters } from "vuex";
import moment from "moment";
import Cookies from "js-cookie";
import { EXPERIMENT_CLOUD_KEY_NAME } from '@/constants/experiments'
import Icon from '@/assets/icons/Icon.vue'
import DialogQuizExit from '@/components/dialogs/DialogQuizExit.vue'
import { ADDITIONAL_QUIZ_STEP, QUESTIONS_LIST } from '@/constants/quiz'
import backArrowIcon from '@/assets/quiz/backArrow.svg'
import logoIcon from '@/assets/quiz/logo.svg'

export default {
  name: 'QuizWrapper',
  components: {
    Icon,
    QuizAnswers,
    DialogQuizExit,
  },

  computed: {
    ...mapGetters({
      profile: 'main/profile',
      dialogs: 'main/dialogs',
      pageDownloadBrowser: 'main/pageDownloadBrowser',
      showAccountPanel: 'main/showAccountPanel'
    }),

    getDropShadowClass() {
      const shadowClasses = {
        'commentQuestion.svg': 'shadow-comment',
        'telegramQuestion.svg': 'shadow-telegram',
        'browserProfilesIcon.svg': 'shadow-browser-profiles',
        'usersQuestion.svg': 'shadow-users',
        'heartsQuestion.svg': 'shadow-hearts',
      };

      return shadowClasses[this.activeQuestion.questionStepIcon] || 'shadow-default';
    },
  },

  props:['visibility', 'handleOnboardingClose'],

  data() {
    return {
      quizItems: [...QUESTIONS_LIST],
      activeQuestion: QUESTIONS_LIST[0],
      skipped: false,
      active: 0,
      showQuizBlock: true,
      affiliateMarketing: false,
      showBackButton: false,
      backArrowIcon,
      logoIcon
    };
  },

  watch: {
    activeQuestion: {
      handler() {
        this.$nextTick(() => {
          const scrollableElement = this.$refs.scrollableWrapper;
          if (scrollableElement) {
            scrollableElement.scrollTop = 0;
          }
        });
      },
      deep: true
    }
  },

  methods: {
    async close (skipped) {
      localStorage.setItem('quizRequired', "0");

      if (skipped) {
        this.activeQuestion.skipped = true
      }

        const analytics = this.quizItems.map(elem => {
        const selectedAnswer = elem.answers.find(answer => answer.selected === true)

        if (selectedAnswer) {
          return [elem.amplitudeName, selectedAnswer.value]
        }

        if (elem.skipped) {
          return [elem.amplitudeName, 'skip']
        }
      }).filter(value => typeof value !== "undefined");

      const quizAnalytics = Object.fromEntries(analytics)

      this.$amplitude.getInstance().logEvent("Quiz", quizAnalytics);

      const {
        'quiz user anti': usageAnty,
        'quiz audience': audience,
        'quiz bp count': bpCount,
        'quiz users count': usersCount
      } = quizAnalytics;

      await this.api.post('/profile/user-intention-quiz-answers', { usageAnty, audience, bpCount, usersCount });

      if (this.showAccountPanel) {
        this.handleOnboardingClose()
      }

      if (this.affiliateMarketing) {
        await this.$store.dispatch('experiments/setUserExperiments', [EXPERIMENT_CLOUD_KEY_NAME])
      }
      this.$store.dispatch('main/closeDialog', 'quizLeavePrompt')

      await this.getUserContact()
    },

    select (value) {
      if (this.active > 1) {
        this.showBackButton = false;
      }
      const { amplitudeName } = this.quizItems[this.active]

      // If user picked the specific answer to the specific question set data to true
      // Otherwise if user picked different answer to the specific question set data to false
      if (amplitudeName === 'quiz audience' && value === 'arbitrage_fb'){
        this.affiliateMarketing = true
      } else if (amplitudeName === 'quiz audience' && value !== 'arbitrage_fb') {
        this.affiliateMarketing = false
      }

      // reset active quiz item
      this.quizItems[this.active].active = false

      const selectedAnswer = this.quizItems[this.active].answers.find(answer => answer.selected === true)

      // Deselect previously selected answer
      if (selectedAnswer) {
        selectedAnswer.selected = false
      }

      // Set selected = true to the answer that was selected in active question
      this.quizItems[this.active].answers.find(answer => answer.value === value).selected = true

      if (this.active === 1 && value === 'other') {
        this.addAdditionalQuizStep();
      }

      this.active++ // change active question

      // Check if next quiz item exists, if not close quiz box and show "Thank you" block
      if (this.quizItems[this.active]) {
        this.quizItems[this.active].active = true

        this.activeQuestion = this.quizItems[this.active]
      } else {
        this.showQuizBlock = false
      }
    },

    handleSliderDotClick (question) {
      if (!question.active && (question.index < this.activeQuestion.index)) {
        const currentActiveQuestionIndex = this.active
        this.quizItems[currentActiveQuestionIndex].active = false
        this.activeQuestion = question

        this.active = question.index
        this.quizItems[this.active].active = true
      }
    },

    back() {
      this.showBackButton = false
      this.quizItems.splice(2, 1)
      this.active = 1
      this.activeQuestion = this.quizItems[this.active]
      this.quizItems[this.active].active = true
    },

    handleClick () {
      const localPath = ['cn', 'es'].includes(this.$i18n.locale) ? 'en' : this.$i18n.locale;
      window.location.href = `${process.env.VUE_APP_BASE_LANDING_URL}${localPath}/download/`;
    },

    goBack() {
      if (this.activeQuestion.amplitudeName === 'quiz additional') {
        this.back()
        return
      }

      if(this.activeQuestion.amplitudeName === 'quiz bp count' && this.active === 3) {
        this.showBackButton = true;
      }

        this.active--
        this.quizItems[this.active].active = true
        this.activeQuestion = this.quizItems[this.active]
    },

    addAdditionalQuizStep() {
      this.showBackButton = true;

      this.quizItems.splice(2, 0, { ...ADDITIONAL_QUIZ_STEP });
    },

    async getUserContact () {
      try {
        const response = await this.api.get('/user/contact')

        if (response?.status === 200 && response.data?.data) {
          const { messenger, messengerIdentifier, userChangedContactThisMonth } = response.data.data
          this.$store.dispatch('main/setSelectedMessenger', messenger)
          this.$store.dispatch('main/setSelectedMessengerValue', messengerIdentifier)
          this.$store.dispatch('main/setUserChangedContactThisMonth', userChangedContactThisMonth)
        }
      } catch (err) {
        console.error(err)
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  .messenger-icon {
    width: 24px;
    height: 24px;
  }

  .download-button {
    background: #a045f6;
    color: white;
    padding: 12px 16px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    cursor: pointer;
  }

  .scrollable-wrapper {
    max-height: 100vh;
    overflow-y: auto;
  }

  .download-button img {
    width: 16px;
    height: 16px;
  }

  .quiz-exit-btn {
    letter-spacing: normal;
  }

  .quiz-exit-btn:hover {
    border-radius: 8px;
  }

  .question-block {
    display: flex;
    background: #ffffff;
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }

  .quiz-smiling-emoji {
    position: relative;
  }

  .quiz-smiling-emoji img {
    position: absolute;
    bottom: 2px;
    left: 4px;
  }

  .question-block-quiz {
    width: 50%;
    height: 100%;
  }

  .question-block div.top-block {
    width: 100%;
  }

  .top-block {
    position: absolute;
    top: 48px;
  }

  .questionWrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 48px;
    align-self: stretch;
  }

  .question-block div.info-block,
  .question-block div.thank-you-block {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    padding: 20px 0 20px 20px;
  }

  .info-block-content {
    position: relative;
    display: flex;
    padding: 48px 80px 40px 80px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1 0 0;
    align-self: stretch;
    border-radius: 24px;
    background: rgba(238, 238, 238, 0.52);
  }

  .info-block-description {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 48px;
    align-self: stretch;
  }

  .workspace-content {
    max-width: 470px;
    font-family: Roboto, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  .workspace-content .help-optimize-maximum-efficiency {
    margin-bottom: 8px;
  }

  .workspace-content-descriptions {
    color: var(--v-text-secondary-base);
    font-family: Roboto, sans-serif;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }

  .return-button {
    cursor: pointer;
    display: flex;
    align-items: center;
    position: absolute;
    bottom: 46px;
  }

  .return-button-text {
    margin-left: 6px;
    color: var(--v-secondary-button-tertiary-foreground-default-base);
    font-family: Roboto, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
    text-transform: capitalize;
  }

  .info-block.quiz-header-block {
    margin-top: 90px;
  }

  .question-block div.info-block h4 {
    font-weight: 400;
    font-size: 16px;
    line-height: 19px;
    color: rgba(40, 51, 74, 0.45);
    margin: 0;
    text-align: center;
  }

  .question-block div.thank-you-block h1 {
    margin: 0 0 20px 0;
    max-width: 20em;
    font-weight: 700;
    font-size: 42px;
    line-height: 49px;
    text-align: center;
    color: #28334a;
  }

  .question-block div.thank-you-block h4 {
    font-weight: 400;
    font-size: 18px;
    line-height: 19px;
    color: #28334a;
    margin: 0;
    text-align: center;
  }

  .question-block div.info-block h1 {
    font-family: Roboto, sans-serif;
    font-size: 36px;
    font-style: normal;
    font-weight: 700;
    line-height: 40px;
    margin-bottom: 24px;
    text-align: start;
    color: var(--v-text-primary-base);
  }

  .quizQuestionSliderWrapper {
    display: flex;
    gap: 7px;
  }

  .quizQuestionSliderDot {
    width: 20px;
    height: 20px;
    background: rgba(182, 69, 238, 0.41);
    border-radius: 50%;
    cursor: pointer;
  }

  .activeDot {
    width: 42px;
    height: 20px;
    background: #B645EE;
    border-radius: 10px;
  }

  .thankYouButton {
    padding: 20px;
    border: 1px solid #b645ee;
    border-radius: 40px;
    background-color: white;
    font-family: "Roboto";
    font-size: 18px;
    cursor: pointer;
    color: #28334a;
    transition: 0.15s;
    display: flex;
    justify-content: center;
    line-height: 25px;
    min-width: 100px;
    margin-top: 20px;
  }

  .thankYouButton img {
    margin-left: 10px;
  }

  .thankYouButton:hover {
    background: rgba(196, 76, 255, 0.85);
    border: 1px solid #9500df;
    color: white;
  }

  .thankYouButton:active {
    background: #9500df;
    border: 1px solid #9500df;
    color: white;
  }

  .email-address-confirmed {
    color: #333;
    font-family: PT Root UI, sans-serif;
    font-size: 18px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    margin-bottom: 0;
  }

  .verified-icon {
    width: 42px;
    height: 42px;
  }

  .notification-bar-verified-container {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    width: 326px;
    height: 60px;
    margin-top: 86px;
    border-radius: 48px;
    background: #E9FF64!important;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 11;
  }

  .question-step-icon {
    width: 80px;
    height: 80px;
  }

  .shadow-comment {
    filter: drop-shadow(0px 20px 48px rgba(136, 0, 205, 0.32));
  }

  .shadow-telegram {
    filter: drop-shadow(0px 20px 48px rgba(0, 205, 116, 0.30));
  }

  .shadow-browser-profiles {
    filter: drop-shadow(0px 20px 48px rgba(0, 143, 205, 0.40));
  }

  .shadow-users {
    filter: drop-shadow(0px 20px 32px rgba(234, 158, 6, 0.40));
  }

  .shadow-hearts {
    filter: drop-shadow(0px 20px 48px rgba(245, 34, 45, 0.24));
  }

  .questionHeader {
    font-family: Roboto, sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 42px;
    line-height: 49px;
    text-align: center;
    color: #28334A;
    max-width: 780px;
  }

  .quiz_user_anti {
    flex-direction: column;
  }

  .quiz_audience {
    max-width: 700px;
  }

  @media (max-width: 1200px) {
    .question-block {
     flex-direction: column;
    }

    .quiz-exit-btn::before {
      background-color: transparent;
    }

    .question-block-quiz {
      width: 100%;
      height: auto;
    }

    .download-btn-anty-browser {
      width: 100%;
    }

    .question-step-icon {
      width: 60px;
      height: 60px;
    }

    .quiz-action-buttons-container {
      width: 100%;
      max-width: 100%;
      flex-direction: column;
    }

    .question-block-two {
      width: 100%;
      align-items: center;
      padding: 24px 16px 60px 16px;
    }

    .return-button {
      position: unset;
      margin-bottom: 14px;
    }
    .question-block div.info-block{
      padding: 16px 16px 0 16px;
    }

    .info-block-description {
      align-items: center;
      gap: 14px;
    }

    .top-block {
      top: 24px;
      left: 30px;
    }

    .small-buttons-quiz-answers button {
      max-width: 100%;
      min-height: 100%;
    }

    .question-block-two img.close-btn {
      top: 48px;
      right: 48px;
    }

    .question-block div.info-block h1 {
      text-align: center;
      font-size: 24px;
      font-style: normal;
      font-weight: 600;
      line-height: 32px;
      margin-bottom: 16px;
    }

    .questionWrapper {
      align-items: center;
      gap: 24px;
    }

    .info-block-content {
      display: block;
      flex-direction: initial;
      justify-content: initial;
      align-items: initial;
      flex: initial;
      padding: 100px 20px 8px 20px;
    }

    .question-block-two {
      justify-content: initial;
      flex: initial;
    }

    .workspace-content {
      max-width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
    }

    .answersWrapper {
      gap: 16px;
    }

    .questionWrapper-block-answer-back-button {
      margin-bottom: 16px;
    }
  }
</style>
